var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.527,
    height: 35.314,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 489"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 488"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 486"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 485"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1997",
    d: "M33.055 0a1.356 1.356 0 00-1.131.58L8.4 33.153a1.363 1.363 0 102.206 1.6l2.206-3.054H41.17a1.357 1.357 0 001.357-1.357V5.004a1.357 1.357 0 00-1.357-1.357h-8.1l1.06-1.47A1.357 1.357 0 0033.056 0zM1.216 3.647A1.358 1.358 0 000 5.004V30.34a1.357 1.357 0 001.357 1.357h4.086a1.358 1.358 0 10.038-2.715H2.714v-3.053l9.049-6.167.9.622a1.359 1.359 0 001.527-2.248l-1.668-1.145a1.365 1.365 0 00-1.527 0l-8.281 5.658V6.362h20.868a1.358 1.358 0 00.038-2.715H1.357q-.07-.003-.141 0zM31.1 6.362h8.709v13.275l-7.263-6.175a1.37 1.37 0 00-1.753 0l-10.519 8.833-.452-.311zM12.215 7.719a3.619 3.619 0 103.619 3.619 3.64 3.64 0 00-3.619-3.619zm0 2.715a.9.9 0 11-.9.9.885.885 0 01.9-.9zm19.454 5.838l8.144 6.928v5.782H14.774l3.464-4.793 1.357.933a1.358 1.358 0 001.64-.085z",
    fill: "#333"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotFound);
export default __webpack_public_path__ + "static/media/image-not-found.8718c89676cf8c4d74cc8d51e6976bc3.svg";
export { ForwardRef as ReactComponent };